<template>
  <!-- 建材砂石 -->
  <div>
    <div class="crTechnology-top"></div>
    <!-- 产融供应链数字服务 -->
    <div class="WuDaHuax">
      <p class="Title">为建材砂石各参与方提供产融供应链数字服务</p>
      <p class="min-Title">
        提供平台化、信息化、数据化的供应链服务及创新税筹服务，让合作伙伴降本增效
      </p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/buildingMaterialsSand/szfw-gtfqw.png" alt="" />
          </div>
          <div class="div1-2">
            <ul>
              <li>固体废弃物</li>
              <li>石英砂</li>
              <li>石灰石</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/newResources/szfw-gtgsh.png" alt="" />
          </div>
          <div class="div1-2">
            <ul>
              <li>个人</li>
              <li>个体户</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/buildingMaterialsSand/szfw-jgc.png" alt="" />
          </div>
          <div class="div1-2">
            <ul>
              <li>商砼站</li>
              <li>加工厂</li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/buildingMaterialsSand/szfw-sgqy.png" alt="" />
          </div>
          <div class="div1-2">
            <ul>
              <li>施工企业</li>
              <li>生产企业</li>
              <li>商贸企业</li>
              <li>事业单位</li>
            </ul>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <div class="div">
        <div class="div0"></div>
        <div class="div2"></div>
        <div class="div0"></div>
      </div>

      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/newResources/szfw-glfw.png" alt="" />
            <p>进销存管理服务</p>
          </div>
          <div class="div1-2">
            <ul>
              <li class="ui-li">
                方便快捷、随时随地管理、查询合同、订单、资金、发票和货物运输等要素的实时状况。
              </li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/newResources/szfw-cgfw.png" alt="" />
            <p>供应链集中采购服务</p>
          </div>
          <div class="div1-2">
            <ul>
              <li class="ui-li">
                有效衔接供需两端，满足下游采购方需求，降低采购方的采购难度和成本。
              </li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/newResources/szfw-jrfw.png" alt="" />
            <p>供应链金融服务</p>
          </div>
          <div class="div1-2">
            <ul>
              <li class="ui-li">
                为采购方、销售方提供供应链金融服务，让建材砂石交易各方轻装上阵无资金压力，助力产业健康发展。
              </li>
            </ul>
          </div>
        </div>
        <div class="div1">
          <div class="div1-1">
            <img src="../../assets/newResources/szfw-swfw.png" alt="" />
            <p>创新税筹服务</p>
          </div>
          <div class="div1-2">
            <ul>
              <li class="ui-li">
                为个人商户、小供应商无区域限制的解决税务困扰、资金周转、物流监管三大难题。
              </li>
            </ul>
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>
    <!-- 5大功能保驾护航 -->
    <div class="WuDaGongn"></div>
    <!-- 数字化操作系统 -->
    <div class="numberczxt">
      <p class="Title">让贸易更简单的数字化操作系统</p>
      <p class="min-Title">
        全程透明可控：工作和数据进展在工作台上一目了然，提升您的工作效率
      </p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 五步解决 -->
    <div class="gylJiaJgct">
      <p class="Title">五步解决您的建材砂石业务</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2">
          <el-button type="primary" round @click="ApplicationProcess">我要入驻</el-button>
        </div>
        <div class="div0 div6"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    ApplicationProcess() {
      this.$router.push("/ApplicationProcess");
    },
  },
};
</script>
<style lang="scss" scoped>
/* 顶部背景图开始 */
.crTechnology-top {
  background: url("../../assets/buildingMaterialsSand/buildingMaterialsSand-banner.png")
    center center no-repeat;
  height: 664px;
  display: flex;
}
.crTechnology-top div {
  margin: auto;
  font-size: 56px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 128px;
}
.crTechnology-top div p {
  font-size: 24px;
  color: #ffffff;
  line-height: 45px;
}
/* 顶部背景图结束 */

/* 产融供应链数字服务开始 */
.WuDaHuax {
  // height: 1132px;
  color: #333333;
  background: #ffffff;
  padding-bottom: 50px;
}
.WuDaHuax > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.WuDaHuax > .min-Title {
  padding: 0 0 50px 0;
}
.WuDaHuax > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
}

.WuDaHuax > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.WuDaHuax > .div .div1 {
  padding: 30px 20px;
  // padding-top: 40px;
  width: 232px;
  // height: 833px;
  margin: 0 20px;
  background: #ffffff;
  box-shadow: 0px 1px 17px 1px rgba(93, 93, 93, 0.13);
  border-radius: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.WuDaHuax > .div .div2 {
  margin-top: 30px;
  width: 1247px;
  height: 595px;
  background: url("../../assets/buildingMaterialsSand/szfw-datu.png") center center
    no-repeat;
}
.WuDaHuax > .div .div1 .div1-1 {
  text-align: center;
  font-size: 24px;
  color: #373d41;
  line-height: 45px;
  margin-bottom: 20px;
}

.WuDaHuax > .div .div1 .div1-1 img {
  width: 92px;
  height: 84px;
  vertical-align: middle;
  // margin-bottom: 16px;
}
.WuDaHuax > .div .div1 .div1-2 {
  text-align: center;
  font-size: 16px;
  color: #373d41;
}
.WuDaHuax > .div .div1 .div1-2 ul li {
  line-height: 28px;
}
.WuDaHuax > .div .div1 .div1-2 ul .ui-li {
  text-align: left;
}
/* 产融供应链数字服务结束 */
/* 5大功能保驾护航开始 */
.WuDaGongn {
  height: 612px;
  background: url("../../assets/buildingMaterialsSand/wdgn-banner.png") center center
    no-repeat;
}
/* 5大功能保驾护航心能力结束 */
/* 数字化操作系统开始 */
.numberczxt {
  padding-bottom: 50px;
  background: #ffffff;
}
.numberczxt > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.numberczxt > .div {
  display: flex;
}

.numberczxt > .div .div1,
.numberczxt > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.numberczxt > .div .div2 {
  margin-top: 20px;
  width: 1232px;
  height: 568px;
  background: url("../../assets/buildingMaterialsSand/number-czxt.png") center center
    no-repeat;
}
/* 数字化操作系统结束 */
/* 五步解决开始 */
.gylJiaJgct {
  height: 704px;
  background: url("../../assets/newResources/wubu-banner.png") center center no-repeat;
}
.gylJiaJgct > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.gylJiaJgct > .div {
  display: flex;
}

.gylJiaJgct > .div .div1,
.gylJiaJgct > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.gylJiaJgct > .div .div2 {
  margin-top: 20px;
  width: 1228px;
  height: 354px;
  background: url("../../assets/newResources/wubu-jk.png") center center no-repeat;
}
.el-button.is-round {
  margin-top: 400px;
  padding: 14px 50px;
  box-shadow: 0px 4px 15px 2px rgb(113, 167, 248);
}
/* 五步解决结束 */
</style>
